import React, { useEffect, useState, useCallback } from 'react';
import { withStyles } from '@material-ui/core/styles';
import {
  Paper, Grid, FormControlLabel, Checkbox,
} from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import PredictionWelcome from './pages/PredictionWelcome';
import { request } from '../../api/client';
import { init } from '../../actions/user-action';
import AustinNextBar from './AustinNextBar';
import { useSlug } from './hooks';
import { getRecaptchaSiteKey } from '../../util/captcha';

const styles = (theme) => ({
  paper: {
    padding: theme.spacing(2),
    fontFamily: 'Roboto Condensed',
    textAlign: 'left',
    border: `1px solid ${theme.palette.divider}`,
    '& hr': {
      margin: theme.spacing(1, 0),
    },
  },
  consentCheckbox: {
    padding: theme.spacing(2),
  },
});

function AustinPredictionWelcome(props) {
  const { classes, nextUrl } = props;
  const dispatch = useDispatch();
  const history = useHistory();
  const slug = useSlug();
  const [recaptcha, setRecaptcha] = useState(null);
  const [isCertified, setCertified] = useState(false);
  const [error, setError] = useState('');
  useEffect(() => {
    window.verifyCallback = (response) => {
      setRecaptcha(response);
      setError('');
    };
  }, []);
  const onCertify = useCallback((evt) => {
    setCertified(evt.target.checked);
  }, [setCertified]);
  const submitVerification = useCallback(
    () => {
      if (recaptcha) {
        request('/api/verify', 'POST', { token: recaptcha, slug }).then((response) => {
          if (!response.ok) {
            setError('error-verify');
          } else {
            response.json().then((body) => {
              dispatch(init({ code: body.code, researchParams: body.research_params }));
              history.push(nextUrl);
            });
          }
        });
      }
    },
    [recaptcha, setError, dispatch, history, nextUrl, slug],
  );
  return (
    <Paper className={classes.paper} elevation={0}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <PredictionWelcome />
          <FormControlLabel
            className={classes.consentCheckbox}
            value={isCertified}
            control={<Checkbox color="secondary" checked={isCertified} onChange={onCertify} />}
            label="Yes, continue to research study"
            labelPlacement="end"
          />
          <div className="g-recaptcha" data-sitekey={getRecaptchaSiteKey()} data-callback="verifyCallback" />
        </Grid>
        <AustinNextBar error={error} disabled={recaptcha == null || !isCertified} disabledPrompt="verify-prompt" onClick={submitVerification} />
      </Grid>
    </Paper>
  );
}

export default withStyles(styles)(AustinPredictionWelcome);
